import { Grid, Stack, Typography } from '@mui/material';
import { FormRadioButton } from '../../common/Form/FormRadioButton';
import PortalModal from '../../common/PortalModal';
import { DELETE_MEETINGS_PERIOD } from '../../common/constants';

export default function DeleteModal({
  course,
  isOpen,
  toggleModalOpen,
  id,
  onConfirm,
  period,
  setPeriod,
}) {
  return (
    <PortalModal
      title={'Delete Meetings'}
      maxWidth="sm"
      isOpen={isOpen}
      onClose={toggleModalOpen}
      isCloseable
      primaryButtonTitle="Delete"
      onPrimaryClick={() => onConfirm(period)}
      secondaryButtonTitle="Cancel"
      onSecondaryClick={toggleModalOpen}
      id={`${id}__modal`}
    >
      <Grid
        id={`${id}__grid_container`}
        container
        direction="column"
        sx={{
          justifyContent: 'center',
        }}
      >
        <Grid item id={`${id}__grid_item_text`} xs={12} xl={3} pt={2}>
          <Typography id={`${id}__text`} variant="small">
            {`Select which meetings${
              course ? ` of ${course.SUBJECT_CODE} ${course.COURSE_NUMBER} - ${course.CRN}` : ''
            } to delete.`}
          </Typography>
        </Grid>
        <Grid item id={`${id}__grid_item_allMeetings`} xs={12} xl={3} pt={2}>
          <Stack
            id={`${id}__stack_allMeetings`}
            direction={'row'}
            spacing={1}
            alignItems={'center'}
          >
            <FormRadioButton
              options={[
                {
                  ariaLabel: 'All Meetings',
                  value: DELETE_MEETINGS_PERIOD.ALL,
                  checked: period === DELETE_MEETINGS_PERIOD.ALL,
                },
              ]}
              id={`${id}__radioButton_allMeetings`}
              labelGridProps={{ xs: 0 }}
              inputGridProps={{ xs: 0, m: 0, p: 0 }}
              onChange={(e) => setPeriod(e.target.value)}
            />
            <Typography
              id={`${id}__text_label_allMeetings`}
              sx={{ whiteSpace: 'nowrap' }}
              variant="small"
            >
              All Meetings
            </Typography>
          </Stack>
        </Grid>
        <Grid item id={`${id}__grid_item_futureMeetings`} xs={12} xl={3}>
          <Stack
            id={`${id}__stack_futureMeetings`}
            direction={'row'}
            spacing={1}
            alignItems={'center'}
          >
            <FormRadioButton
              options={[
                {
                  ariaLabel: 'Future Meetings',
                  value: DELETE_MEETINGS_PERIOD.FUTURE,
                  checked: period === DELETE_MEETINGS_PERIOD.FUTURE,
                },
              ]}
              id={`${id}__radioButton_futureMeetings`}
              labelGridProps={{ xs: 0 }}
              inputGridProps={{ xs: 0, m: 0, p: 0 }}
              onChange={(e) => setPeriod(e.target.value)}
            />
            <Typography
              id={`${id}__text_label_futureMeetings`}
              sx={{ whiteSpace: 'nowrap' }}
              variant="small"
            >
              Future Meetings
            </Typography>
          </Stack>
        </Grid>
      </Grid>
    </PortalModal>
  );
}
